import { render, staticRenderFns } from "./replacementList.vue?vue&type=template&id=0249ed37&scoped=true&"
import script from "./replacementList.vue?vue&type=script&lang=js&"
export * from "./replacementList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0249ed37",
  null
  
)

export default component.exports